import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['content'];

  static values = {
    target: String
  };

  connect() {
    if (this.containerElement) {
      this._showContent(this.containerElement.value);
    }
  }

  change(event) {
    this._showContent(event.target.value);
  }

  get containerElement() {
    if (this.hasTargetValue) {
      return document.querySelector(this.targetValue);
    }

    return this.element;
  }

  _showContent(activeValue) {
    this.contentTargets.forEach((content) => {
      const contentValue = content.dataset.revealValue;
      if (contentValue === activeValue) {
        content.classList.remove('d-none');
      } else {
        content.classList.add('d-none');
      }
    });
  }
}
